import { signInWithEmailAndPassword } from 'firebase/auth';

import { USER_TYPES } from '../Constant/Enums';

import { prepareFirebaseAuth } from './firebaseClients';

const mapFirebaseUser = user => ({
  uid: user.uid,
  name: user.displayName,
  email: user.email,
  emailVerified: user.emailVerified,
  phoneNumber: user.phoneNumber,
  photoURL: user.photoURL,
  createdAt: user.metadata.creationTime,
});

const FirebaseAdmin = {
  signIn: async (email, password) => {
    try {
      const auth = await prepareFirebaseAuth(USER_TYPES.ADMIN);
      const response = await signInWithEmailAndPassword(auth, email, password);

      return {
        data: mapFirebaseUser(response.user),
        errors: null,
      };
    } catch (error) {
      return { data: null, errors: error.code };
    }
  },
};

export default FirebaseAdmin;
